
export let isMobile = false

export const checkIsMobile = (): boolean => {
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
  isMobile = mobileRegex.test(navigator.userAgent)
  return isMobile
}

export const isSafari = () => {
  return navigator.userAgent.toLowerCase().includes('safari') && !navigator.userAgent.toLowerCase().includes('chrome')
}
